module.exports = __webpack_public_path__ + "static/img/bigTerra.1061058f.jpg";